var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeTrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-761 -345) translate(471 295) translate(290 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F2F3EF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.414,
    fill: "#E3EDC3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 15.128,
    fill: "#F4FBFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 1.564,
    fill: "#365E7D"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#274642"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9.528c.324 0 .586-.262.586-.586v-.86c0-.324-.262-.586-.586-.586-.324 0-.586.262-.586.586v.86c0 .324.262.586.586.586zM28.81 11.172c-.229-.23-.6-.23-.829 0l-.608.608c-.229.228-.229.6 0 .828.115.115.264.172.415.172.15 0 .3-.057.414-.172L28.81 12c.229-.229.229-.6 0-.828zM30.994 19.414c-.323 0-.586.262-.586.586 0 .324.263.586.586.586h.86c.324 0 .586-.262.586-.586 0-.324-.262-.586-.586-.586h-.86zM28.157 27.373c-.23-.229-.6-.229-.829 0-.229.229-.229.6 0 .829l.608.608c.114.114.264.171.414.171.15 0 .3-.057.415-.171.229-.23.229-.6 0-.829l-.608-.608zM19.35 30.994v.86c0 .324.263.586.586.586.324 0 .586-.262.586-.586v-.86c0-.323-.262-.585-.586-.585-.323 0-.586.262-.586.585zM11.734 27.328l-.608.608c-.228.229-.228.6 0 .829.115.114.265.171.415.171.15 0 .3-.057.414-.171l.608-.608c.229-.23.229-.6 0-.829-.229-.229-.6-.229-.829 0zM8.082 19.35c-.324 0-.586.263-.586.586 0 .324.262.586.586.586h.86c.323 0 .586-.262.586-.586 0-.323-.263-.586-.586-.586h-.86zM12.608 11.735L12 11.126c-.229-.228-.6-.228-.829 0-.228.23-.228.6 0 .83l.609.607c.114.115.264.172.414.172.15 0 .3-.057.414-.172.23-.229.229-.6 0-.828zM25.744 23.612c.29.15.642.033.789-.253.148-.288.034-.64-.253-.789l-4.172-2.145c.027-.138.042-.28.042-.425 0-.982-.663-1.812-1.564-2.068V11.96c0-.324-.262-.586-.586-.586-.324 0-.586.262-.586.586v5.972c-.715.203-1.279.767-1.482 1.482h-2.908c-.324 0-.586.262-.586.586 0 .324.262.586.586.586h2.908c.256.901 1.086 1.564 2.068 1.564.62 0 1.178-.264 1.57-.684l4.174 2.146zM20 20.978c-.54 0-.978-.439-.978-.978 0-.54.439-.978.978-.978.54 0 .978.439.978.978 0 .54-.439.978-.978.978z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.128 19.413c.323-.025.565-.306.54-.629-.302-3.937-2.065-7.592-4.966-10.29C27.786 5.78 23.985 4.285 20 4.285c-8.665 0-15.714 7.05-15.714 15.714 0 8.665 7.05 15.714 15.714 15.714 8.195 0 15.04-6.313 15.668-14.498.024-.322-.217-.604-.54-.629-.321-.024-.604.217-.629.54-.578 7.557-6.9 13.415-14.499 13.415-8.019 0-14.542-6.523-14.542-14.542S11.98 5.458 20 5.458c3.688 0 7.205 1.382 9.904 3.893 2.684 2.498 4.316 5.88 4.595 9.523.025.322.306.564.63.539z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.142 5.858C30.365 2.08 25.342 0 20 0c-3.84 0-7.569 1.09-10.786 3.155-.272.175-.351.537-.177.81.175.272.537.351.81.176C12.875 2.2 16.386 1.171 20 1.171c5.03 0 9.757 1.96 13.314 5.515 3.556 3.557 5.514 8.285 5.514 13.314 0 10.406-8.42 18.828-18.828 18.828-1.86 0-3.699-.271-5.467-.807-.31-.094-.636.081-.73.391-.094.31.081.637.39.73 1.879.57 3.832.858 5.807.858 11.053 0 20-8.945 20-20 0-5.342-2.08-10.365-5.858-14.142zM12.403 37.231C5.58 34.22 1.172 27.455 1.172 20c0-5.633 2.493-10.925 6.84-14.519.25-.206.284-.575.078-.825-.206-.249-.575-.284-.825-.078C2.648 8.395 0 14.016 0 20c0 7.919 4.683 15.103 11.93 18.303.076.034.157.05.236.05.225 0 .44-.13.536-.35.13-.295-.003-.641-.3-.772z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTrial);
export default __webpack_public_path__ + "static/media/free-trial.2deb326d99670acdd03f1fd0cda1d1b4.svg";
export { ForwardRef as ReactComponent };